import fetchServer from "../../fetchServer";

export async function getAdminCustomKey(accountId) {
  let result = {
    return: 0,
    msg: "Something went wrong getting admin custom keys!",
  };

  await fetchServer({
    method: "GET",
    url: `/product/v1/adminCustomKey/${accountId}`,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
